import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Row, Col } from 'reactstrap';
import { Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import classnames from 'classnames';
import { toast } from 'react-toastify';

import DateTime from 'react-datetime';
import moment from 'moment';

import { ButtonWithLoader, OroDatePicker, OroDobPicker } from '../../../core';
import { onboardingService } from '../../services/onboarding';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { store } from '../../../store';
import { setOnboardingDataForAddPan } from "../../../actions";
import { middlewareService } from '../../../../src/shared/service';
import middlewareConstants from '../../../../src/shared/middleware-constant';
import { consentService } from '../../services/consent';
class KycCheck extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCanFields: false,
      can: '',
      pan: '',
      canEmail: '',
      dob: '',
      formattedDate: '',
      fullname: '',
      nickname: '',
      errors:  {},
      consentChecked: false,
      consent: {}
    };

    this.setDob = this.setDob.bind(this);
    this.performKycCheck = this.performKycCheck.bind(this);
    this.toggleCanState = this.toggleCanState.bind(this);
    this.showSuccessNotification = this.showSuccessNotification.bind(this);
  }

  componentDidMount() {
    this.setState({
      canEmail: store.getState().user.userDetails && store.getState().user.userDetails.info.email
    });
    this.getConsent()
  }

  getConsent = () => {
    consentService.getConsent("kyc")
    .then(response => {
      if (!response || !response.success) {
        return toast.error("something went wrong!")
      }

      this.setState({
        consent: response.data
      })
    })
  }

  setDob(date) {

    if (this.props.isBseFlow) {
      var userInput = date.dob
      var currentDate = moment();
      var differene = currentDate.diff(userInput, 'years', true);

      if (differene < 18) {
        this.setState({
          errors: {
            general: "We currently do not support onboarding for Minors (individuals under the age of 18 years). Please contact connect@orowealth.com for further details."
          }
        });
        return
      }

      if (!this.state.errors.panError) {
        this.setState({
          errors: {
            general: ""
          }
        });
      }
    }
    this.setState(date);
  }

  toggleCanState() {
    this.setState({
      showCanFields: !this.state.showCanFields
    })
  }

  checkPanKYC = (input) => {
    let {mfuUser} = input || {};
    onboardingService.addPan(this.state.dob.format('DD/MM/YYYY'), this.state.pan, this.state.fullname, this.state.nickname, this.props.type === 'add-account', this.props.isBseFlow)
        .then(kycCheck => {
          if(kycCheck.status && kycCheck.status.response === 'success') {
            this.setState({
             submitting: false
            });
            this.props.onComplete(this.props.stepName, {
              kycVerificationStatus: kycCheck.status.message,
              kycData: kycCheck.data
            });            
          } else {
            if (mfuUser) {
              this.setState({
                submitting: false, 
                errors: {
                  general: "We have received your information. Our team will reach out to you for further steps to complete onboarding."
                }
              });
            } else{
              this.setState({
                submitting: false, 
                errors: {
                  general: kycCheck.status.userMessage
                }
              });
            }
            
          }
        });
  }

  performKycCheck(e) {
    e.preventDefault();
    this.sendConsent()
    store.dispatch(setOnboardingDataForAddPan(this.state));

    this.setState({
      submitting: true
    });

    if(this.state.showCanFields) {
      if(this.state.can && this.state.canEmail) {
        var params = {
          dob: this.state.dob.format('DD-MM-YYYY'), 
          pan: this.state.pan,
          can: this.state.can,
          canEmail: this.state.canEmail
        };

        if(this.props.type === 'add-account') {
          params['fullname'] = this.state.fullname;
          params['nickname'] = this.state.nickname;
        }

        onboardingService.setCanDetails(params)
        .then(response => {
          if(!response.appSuccess) {
            this.setState({
              errors: {
                general: response.error+', ' + response.message
              },
              submitting: false
              }, () => {
            })
          } else {
            if (this.state.showCanFields) {
              this.showSuccessNotification('CAN added successfully.');
              this.setState({
                submitting: false
              }, () => {
                  this.props.onComplete(this.props.stepName, {
                  kycVerificationStatus: "CAN added successfully.",
                  kycData: params
                });
              });
            } else { 
              this.setState({
                submitting: false
              }, () => {
                this.props.onComplete(this.props.stepName, {kycVerificationStatus: 'Verified Kyc'});
              })
            } 
          }
        })
      } else {
        this.setState({
          submitting: false,
          errors: {
            can: !this.state.can ? 'This is a required field.' : '',
            canEmail: !this.state.canEmail ? 'This is a required field.' : ''
          }
        })
      }
    } else {
      if (this.props.isBseFlow) {

        let _url = '/bse/account/checkPan'
        let payload = {
          pan : this.state.pan
        }
        let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE
        requestOptions.body = JSON.stringify(payload);
        middlewareService.servicePost(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
          .then(resp => {
            if (!resp.success && resp.error) {
              this.setState({
                submitting: false,
                errors: {
                  general: resp.error
                  }
                });

                this.props.onComplete(this.props.stepName, {
                  othersPan: true
                });
                return;
            } else {
              this.checkPanKYC();
            }
          });
      } else {
        this.checkPanKYC({mfuUser: true});
  
      } 
    }
  }

  showSuccessNotification(message) {
    return toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: true
    });
  }

  checkPan =(e) => {
    let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regpan.test(e.target.value)) {
      return true;
    }else {
      return false;
    }
  }

  inputPan = (e) => {
    let panError = "";
    if (e.target && e.target.value && e.target.value.length === 10) {
      panError = this.checkPan(e) ? "" : "Please Enter a valid PAN"
    }
    this.setState({
      pan: e.target.value.toUpperCase(),
      errors: {
          general: panError,
          panError: panError === "" ? false : true
      }
    })
  }

  checkPan =(e) => {
    let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regpan.test(e.target.value)) {
      return true;
    }else {
      return false;
    }
  }

  sendConsent = () => {
    if (this.state.consentChecked) {
      let payload = {
        version: this.state.consent.version
      }

      consentService.sendConsent("kyc", payload)
      .then(response => {
        if (response) {
          console.log("we have send the consent")
        }
      })
    }
  }

  checkConsent = (e) => {
    this.setState({
      consentChecked: e.target.checked
    })
  }

  render() {
    return (
      <Row className="justify-content-center kyc-check-form">
        <Col xs={12} md={6} lg={5}>
          <h2 className="font-weight-semi-bold font-size-triple mb-6">
            {
              this.props.type === 'add-account' ? 'Add an account' : 'Let\'s check if you are ready to invest'
            }
          </h2>
        </Col>
        <Col xs={12} md={6} lg={5}>
          <Row>
            {
              this.state.errors && this.state.errors.general ? (             
                <Col xs="12">
                  <Alert color={this.props.isBseFlow ? "danger" : "success" }>
                    { this.state.errors.general }
                  </Alert>
                </Col>
              ) : ''
            }
          </Row>

          <Form className="login-form" onSubmit={this.performKycCheck}>
            {
              this.props.type === 'add-account' ? (
                <div>
                  <FormGroup>
                    <Label for="fullname" 
                            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.fullname })} >
                            Full Name
                    </Label>

                    <Input type="text" 
                           name="fullname" 
                           id="fullname" 
                           className="form-control font-weight-semi-bold"
                           placeholder="Full Name" 
                           onChange={e => this.setState({fullname: e.target.value})}
                           value={this.state.fullname}
                           />
                  </FormGroup>

                  <FormGroup>
                    <Label for="nickname" 
                            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.nickname })} >
                            Nick Name
                    </Label>

                    <Input type="text" 
                           name="nickname" 
                           id="nickname" 
                           className="form-control font-weight-semi-bold"
                           placeholder="Nick Name" 
                           onChange={e => this.setState({nickname: e.target.value})}
                           value={this.state.nickname}
                           />
                  </FormGroup>
                </div>
              ) : ''
            }

            <FormGroup>
              <Label for="pan" 
                      className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.pan })} >
                      PAN
              </Label>

              <Input type="text" 
                     name="pan" 
                     id="pan" 
                     className="form-control font-weight-semi-bold"
                     placeholder="PAN" 
                     onChange={e => this.inputPan(e)}
                     value={this.state.pan}
                     />
            </FormGroup>

            <OroDobPicker 
              label="Date of birth"
              onDateUpdated={this.setDob}
              />

            {
              this.state.showCanFields ? (
                <div className="can-details">
                  <FormGroup>
                    <Label for="can" 
                            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.can })} >
                            CAN
                    </Label>

                    <Input type="text" 
                           name="can" 
                           id="can" 
                           className="form-control font-weight-semi-bold"
                           placeholder="CAN" 
                           onChange={e => this.setState({can: e.target.value})}
                           value={this.state.can}
                           />
                  </FormGroup>

                  <FormGroup>
                    <Label for="canEmail" 
                            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.canEmail })} >
                            CAN Email
                    </Label>

                    <Input type="email" 
                           name="canEmail" 
                           id="canEmail" 
                           className="form-control font-weight-semi-bold"
                           placeholder="CAN Email" 
                           value={this.state.canEmail} 
                           disabled={true}
                           />
                  </FormGroup>
                </div>
                ) : ''
            }
            
            <FormGroup className="cta-block pt-2 mt-0">
              <div className="d-flex pb-4 font-size-14 flex-direction-row p-2 pl-4">
                <div>
                  <Input type="checkbox"
                    onChange={e => this.checkConsent(e)}
                    checked={this.state.consentChecked} />
                                {ReactHtmlParser(this.state.consent.text)}
                </div>
              </div>
              
              <ButtonWithLoader 
                    text="Check now" 
                    isLoading={this.state.submitting} 
                    color="primary" 
                    className="w-100"
                    disabled={!(this.state.pan && this.state.pan.length > 0 && this.state.dob) || this.state.errors.general || !this.state.consentChecked || this.state.panError}
                    />
                    { 
                      !this.props.isBseFlow &&
                      <p className="text-primary text-center my-3 cursor-pointer font-size-small" onClick={this.toggleCanState}>
                        {
                          this.state.showCanFields ? 'I don\'t have a CAN number' : 'Add existing CAN?'
                        }
                      </p>
                    }
            </FormGroup>
          </Form>  
        </Col>
      </Row>
    );
  }
}

export default KycCheck;